<template>
  <TheSaib v-if="$store.state.auth.isSignin">
    <template v-slot:buttons>
      <a-button
        style="margin: 5px;"
        type="danger"
        icon="delete"
        shape="round"
        class="fl-right"
        @click="deleteSaibs"
      >{{ isPC ? '삭제' : '' }}</a-button>
      <a-button
        style="margin: 5px;"
        type="default"
        icon="edit"
        shape="round"
        class="fl-right"
        @click="getSaibsEdit"
      >{{ isPC ? '수정' : '' }}</a-button>
      <a-button
        style="margin: 5px;"
        type="primary"
        icon="plus"
        shape="round"
        class="fl-right"
        @click="$router.push('/saib/selector');"
      >{{ isPC ? '추가' : '' }}</a-button>
    </template>
    <table class="list-type-2" v-if="$store.state.saib.saibs.length > 0">
      <thead>
        <tr>
          <td>
            <a-checkbox
              @click="onSelectedAll"
              :indeterminate="$store.state.saib.indeterminate"
              :checked="$store.state.saib.selectedAll"
            >선택</a-checkbox>
          </td>
          <td>상태</td>
          <td v-if="isPC">매장 이름</td>
          <td v-if="isPC">
            위치
            <br />소속상가 (층/열/호)
          </td>
          <td v-if="isPC">금액</td>
          <td v-if="isPC" class="order-detail">주문 내역</td>
          <td v-if="isPC">등록 시간</td>
        </tr>
      </thead>
      <tbody>
        <SaibItem
          v-for="(saib, index) in $store.state.saib.saibs"
          :key="index"
          :idx="saib.idx"
          :status="saib.status"
          :wholesale="saib.wholesale"
          :price="saib.price"
          :details="saib.details"
          :uploadAt="$moment(saib.uploadAt)"
        />
      </tbody>
    </table>
    <div class="card-empty" v-else>
      <i class="no-content-logo"></i>
      <p>아직 소매가 없습니다.</p>
    </div>

    <template v-slot:pageing>
      <div class="pagination p1">
        <ul>
          <a href="#">
            <li>
              <i class="arrow-type2 right"></i>
            </li>
          </a>
          <a class="is-active" href="#">
            <li>1</li>
          </a>
          <a href="#">
            <li>2</li>
          </a>
          <a href="#">
            <li>3</li>
          </a>
          <a href="#">
            <li>4</li>
          </a>
          <a href="#">
            <li>5</li>
          </a>
          <a href="#">
            <li>6</li>
          </a>
          <a href="#">
            <li>
              <i class="arrow-type2 left"></i>
            </li>
          </a>
        </ul>
      </div>
    </template>
  </TheSaib>
</template>
<script>
import TheSaib from "@/components/Saib/TheSaib";
import SaibItem from "@/components/Saib/SaibItem";
import { mapActions } from "vuex";
import { TYPES } from "../../stores/saib";

export default {
  name: "SaibStatus",
  components: { TheSaib, SaibItem },
  methods: {
    ...mapActions(["refreshSaibs", "getSaibsEdit", "deleteSaibs"]),
    onSelectedAll() {
      this.$store.commit(TYPES.SWITCH_ALL_SAIB);
    }
  },
  mounted() {
    this.refreshSaibs();
  }
};
</script>